import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { ThemeProvider } from '@mui/material';

import { theme } from '@hbf/dsl';
import {
  DateRangePicker,
  DATEPICKER_VARIANT,
  DateRange,
} from '@ha/marketplace/feature-date-picker';
import { constants } from 'ha/constants/commonConstants';
import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import { DateRangePickerInputs } from './DateRangePickerInputs';
import { DatePickerFieldValue } from '../../types';

const HomeDateRangePicker: React.FC<FieldRenderProps<DatePickerFieldValue>> = ({
  input,
}) => {
  const { value } = input;
  const { T, formatDate, locale } = useIntl();
  const { sm } = useMediaQuery();

  const datePickerValue: DateRange = React.useMemo(
    () => ({
      from: value.startDate ?? undefined,
      to: value.endDate ?? undefined,
    }),
    [value],
  );

  const handleDateChange = React.useCallback(
    (inputValue: DateRange) => {
      input.onChange({
        startDate: inputValue.from ?? null,
        endDate: inputValue.to ?? null,
      });
    },
    [input],
  );

  return (
    // use the default theme since homepage uses the custom one and overwrites fonts */
    <ThemeProvider theme={theme}>
      <DateRangePicker
        value={datePickerValue}
        onDateChange={handleDateChange}
        variant={DATEPICKER_VARIANT.RESPONSIVE}
        clearDatesButton={T('Reset')}
        DatePickerInputs={DateRangePickerInputs}
        noEndDate
        showSingleMonth={!sm}
        T={T}
        formatDate={formatDate}
        localeString={locale}
        listingFlexibleDays={constants.listingFlexibleDays}
      />
    </ThemeProvider>
  );
};

export { HomeDateRangePicker };
